













import Vue from 'vue';
import { Component } from 'vue-property-decorator';
@Component({
  components: {
    Recent: () => import('./components/recent.vue'),
    Lesson: () => import('./components/lesson.vue'),
    Course: () => import('./components/course.vue')
  }
})
export default class Teaching extends Vue {}
